/**
 * Il componente interno alla dropdown, è possibile selezionare la checkbox per includere l'elemento nella ricerca o deselezionarlo
 * è composto da una checkbox con la quale selezionare o deselezionare l'elemento e una label ad indicarne la label da mostrare a interfaccia
 *
 * @param {string} value - Il valore della checkbox.
 * @param {function} onChange - La funzione da chiamare quando la checkbox viene cliccata.
 * @param {boolean} defaultChecked - Se la checkbox è selezionata di default.
 * @param {boolean} showIcon - Se il componente deve mostrare un'icona.
 * @param {string} label - il testo della checkbox.
 *
 */
export function SelectableElement({
  value = '',
  onChange = (value) => {},
  defaultChecked = false,
  showIcon = false,
  label = ''
}) {
  return (
    <div
      title={label}
      className={`d-flex align-items-center selectable-element w-100 ${showIcon ? '' : 'ms-2'}`}>
      {showIcon && <i className="star-icon-drag star-icon ms-1 me-2" />}
      <input
        type="checkbox"
        value={value}
        defaultChecked={defaultChecked}
        onClick={() => {
          onChange(value)
        }}
      />
      <label className="ms-2 mb-0 ellipsis col me-3" htmlFor={label}>
        {label}
      </label>
    </div>
  )
}
